<template>
  <div class="tab-bar">
    <div 
      v-for="(item, index) in tabList" 
      :key="index"
      class="tab-item"
      :class="{ active: currentPath === item.path }"
      @click="handleTabClick(item.path)"
    >
      <img :src="currentPath === item.path ? item.selectedIcon : item.icon" class="tab-icon" alt="">
      <span class="tab-text">{{ item.text }}</span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'TabBar',
  data() {
    return {
      tabList: [
        { 
          text: '首页', 
          path: '/index',
          icon: require('@/assets/images/home-icon.png'),
          selectedIcon: require('@/assets/images/home-icon-active.png')
        },
        { 
          text: '借款', 
          path: '/borrow',
          icon: require('@/assets/images/loan-icon.png'),
          selectedIcon: require('@/assets/images/loan-icon-active.png')
        },
        { 
          text: '信息', 
          path: '/info',
          icon: require('@/assets/images/info-icon.png'),
          selectedIcon: require('@/assets/images/info-icon-active.png')
        },
        { 
          text: '我的', 
          path: '/my',
          icon: require('@/assets/images/user-icon.png'),
          selectedIcon: require('@/assets/images/user-icon-active.png')
        }
      ]
    }
  },
  computed: {
    currentPath() {
      return this.$route.path
    }
  },
  methods: {
    handleTabClick(path) {
      if (this.$route.path !== path) {
        this.$router.push(path)
      }
    }
  }
}
</script>

<style scoped>
.tab-bar {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  height: 56px;
  padding-bottom: env(safe-area-inset-bottom);
  background: linear-gradient(180deg, #ffffff 0%, #fafafa 100%);
  display: flex;
  box-shadow: 0 -4px 20px rgba(0, 0, 0, 0.08);
  z-index: 100;
  border-top: 1px solid rgba(0, 0, 0, 0.05);
}

.tab-item {
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all 0.25s cubic-bezier(0.4, 0, 0.2, 1);
  padding: 6px 0;
  position: relative;
}

.tab-item:active {
  transform: scale(0.96);
}

.tab-icon {
  width: 26px;
  height: 26px;
  margin-bottom: 3px;
  transition: all 0.25s cubic-bezier(0.4, 0, 0.2, 1);
  filter: drop-shadow(0 1px 2px rgba(0, 0, 0, 0.05));
}

.tab-text {
  font-size: 11px;
  color: #9ca3af;
  font-weight: 500;
  transition: all 0.25s cubic-bezier(0.4, 0, 0.2, 1);
  letter-spacing: 0.3px;
}

.tab-item.active .tab-text {
  color: #0FB54C;
  font-weight: 600;
}

.tab-item.active::before {
  content: '';
  position: absolute;
  top: 0;
  left: 50%;
  transform: translateX(-50%);
  width: 32px;
  height: 3px;
  background: linear-gradient(to right, #0FB54C, #8DC641);
  border-radius: 0 0 3px 3px;
}
</style>
